module.exports = __webpack_public_path__ + "static/media/MostlyCloudy.d5fd287b.svg";